import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { MarketingPlan } from './MarketingPlan';
import { SalesPlan } from './SalesPlan';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKETING_AND_SALES.SALES_PLAN]: SalesPlan,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKETING_AND_SALES.MARKETING_PLAN]: MarketingPlan,
};

export const MarketingAndSales: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
